import { render, staticRenderFns } from "./handleConsult.vue?vue&type=template&id=567c1567&scoped=true"
import script from "./handleConsult.vue?vue&type=script&lang=js"
export * from "./handleConsult.vue?vue&type=script&lang=js"
import style0 from "./handleConsult.vue?vue&type=style&index=0&id=567c1567&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c1567",
  null
  
)

export default component.exports